import {networker} from "@/service/http";

const freeKassaService = {
    getMethods(walletId){
        return networker.get(`payment/fk/method/${walletId}`)
    }
}

export default freeKassaService